import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useTranslations } from "next-intl";
import { FindYourSchool } from "@/components/find-your-school";
import { PageShell, Text } from "@/components/ui";
import { useAuthStore } from "@/stores/authStore";

/**
 * MT-1 Plan 6 S16 (FR-20): signed-in users go to their own school; a signed-out visitor gets the
 * neutral "Find your school" page. There is no default school.
 */
export function HomePage() {
  const navigate = useNavigate();
  const t = useTranslations("tenantPublic");
  const user = useAuthStore((s) => s.user);
  const hasHydrated = useAuthStore((s) => s.hasHydrated);

  useEffect(() => {
    if (!hasHydrated) return;
    if (user?.tenantSlug) navigate(`/t/${user.tenantSlug}/dashboard`, { replace: true });
  }, [hasHydrated, navigate, user?.tenantSlug]);

  if (hasHydrated && !user?.tenantSlug) return <FindYourSchool />;

  return (
    <PageShell data-testid="spa-shell">
      <Text tone="muted" className="text-center">
        {t("loading")}
      </Text>
    </PageShell>
  );
}
